"use client"

export { trackEvent } from "./eventing"
